const subscriptions = (state = [], action) => {
    if (action.error) {
        return state;
    }

    switch (action.type) {
        case 'TEAM_CHANGE':
        case 'RESET_STORE':
            return [];

        case 'SUBSCRIPTIONS_FETCH_SUCCEEDED':
            return [...(action.payload.subscriptions || [])];

        case 'SUBSCRIBE_REQUESTED':
        case 'SUBSCRIBE_SOCKET':
            if (state.includes(action.payload.association_id)) {
                return state;
            }

            return [...state, action.payload.association_id];

        case 'UNSUBSCRIBE_REQUESTED':
        case 'UNSUBSCRIBE_SOCKET':
            return state.filter(subscription => subscription !== action.payload.association_id);

        default:
            return state;
    }
}

export default subscriptions;
